import ConvertirStringHTML from "../ConvertirStringHTML";
import checkIconNew from "../../assets/check-square_new.png";

// Montos AR: $4.700.000 o tipográficos $4.7000.000 — no cortar en el 1er grupo de miles
const MONEY_RE = /(\$\s?\d[\d.]*(?:,\d{1,2})?)/;

export const isUsadoCopy = (text = "") => /usado/i.test(String(text));

const cleanText = (raw = "") =>
  String(raw || "")
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<[^>]+>/g, "")
    .replace(/\s+/g, " ")
    .trim();

export const isAdjudicacionCopy = (text = "") =>
  /^adjudicaci[oó]n asegurada\.?$/i.test(cleanText(text));

const isMeaningfulCopy = (raw = "") => {
  const text = cleanText(raw).replace(/^[\s,;.\-–—]+$/, "");
  return Boolean(text);
};

export const parseOfferText = (raw = "") => {
  const text = cleanText(raw);

  if (!text) return null;

  const match = text.match(MONEY_RE);
  if (!match) return { type: "plain", text };

  const after = text
    .slice(match.index + match[0].length)
    .replace(/^[\s,;:\-–—]+/, "")
    .trim();

  return {
    type: "priced",
    before: text.slice(0, match.index).trim(),
    amount: match[1].replace(/\s+/g, ""),
    after,
  };
};

export const CardNuevoKicker = () => (
  <p className="card-offer-nuevo">
    <img src={checkIconNew} alt="" width="16" height="16" />
    <span>Nuevo modelo</span>
  </p>
);

const CardOffer = ({
  title,
  description,
  highlight,
  extraHighlight = "",
  isNew = false,
  hideUsadoHighlight = true,
  plainAs = "plain",
  skipPricedDescription = false,
  fixedSlot = true,
}) => {
  const parsed = parseOfferText(title);
  const highlightText =
    hideUsadoHighlight && isUsadoCopy(highlight) ? "" : isMeaningfulCopy(highlight) ? highlight : "";
  const extra = isMeaningfulCopy(extraHighlight) ? extraHighlight : "";
  const thirdLine = highlightText || extra || "";
  const descRaw = isMeaningfulCopy(description) ? description : "";
  const descText = hideUsadoHighlight && isUsadoCopy(descRaw) ? "" : descRaw;
  const parsedDesc = parseOfferText(descText);
  const priceInDesc =
    (parsed?.type === "priced" && descText.replace(/\s/g, "").includes(parsed.amount.replace(/\s/g, ""))) ||
    (skipPricedDescription && parsedDesc?.type === "priced");

  const headlineClass = plainAs === "highlight" ? "card-offer-highlight" : "card-offer-headline";
  const secondaryClass =
    plainAs === "highlight" ? "card-offer-highlight" : "vehicle-footer-titulo-principal-b";
  const hasPriced = parsed?.type === "priced";
  const showDesc = Boolean(descText && !priceInDesc && hasPriced);
  const showNuevo = Boolean(isNew) && !hasPriced;
  const showPlainTitle = !hasPriced && isMeaningfulCopy(title);
  const showPlainDesc =
    !hasPriced && Boolean(descText && !priceInDesc && parsedDesc?.type !== "priced");

  const slotClass = [
    "card-offer",
    fixedSlot ? "" : "card-offer--compact",
    !hasPriced && fixedSlot ? "card-offer--copy" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={slotClass}>
      {showNuevo ? <CardNuevoKicker /> : null}

      {hasPriced ? (
        <>
          {parsed.before ? <p className="card-offer-label">{parsed.before}</p> : null}
          <p className="card-offer-number">{parsed.amount}</p>
          {parsed.after ? <p className="card-offer-highlight">{parsed.after}</p> : null}
        </>
      ) : (
        <>
          {showPlainTitle ? ConvertirStringHTML(String(title).trim(), headlineClass) : null}
          {showPlainDesc ? ConvertirStringHTML(String(descText).trim(), secondaryClass) : null}
        </>
      )}

      {showDesc ? ConvertirStringHTML(descText, "vehicle-footer-titulo-principal-b") : null}

      {thirdLine ? ConvertirStringHTML(thirdLine, "vehicle-footer-titulo-principal-c") : null}
    </div>
  );
};

export default CardOffer;
